import {
  gql, useQuery 
} from "@apollo/client";
import {
  useMemo 
} from "react";

// 定义GraphQL查询
const GET_ALL_FABRIC_PRODUCTS = gql`
  query GetAllFabricProducts($pageSize: Int = 12, $currentPage: Int = 1) {
    allFabricProduct(pageSize: $pageSize, currentPage: $currentPage) {
      fabric
      items {
        id
        uid
        name
        fabrics_mark
        stock_status
        version
        price_range {
            maximum_price {
                final_price {
                    currency
                    value
                }
                regular_price {
                    currency
                    value
                }
                discount {
                    amount_off
                }
            }
            minimum_price {
                final_price {
                    currency
                    value
                }
                regular_price {
                    currency
                    value
                }
                discount {
                    amount_off
                }
            }
        }
        sku
        image {
            url(type: "thumbnail", width: 320, height: 470)
        }
        hover_image(width: 320, height: 470)
        small_image {
            url(type: "thumbnail", width: 90, height: 132)
        }

        # TODO: 尺寸处理，列表色块
        show_colors(
            width: 692
            height: 1016
        ) {
            items {
                label
                rgb
                image
                hover_image
                small_image
                small_hover_image
                is_selected
            }
            total
        }
        product_mark
        video_url
        stock_status
        rating_summary
        review_count
        __typename
        url_key
      }
    }
  }
`;

// 定义返回数据的接口
interface AllFabricProductData {
  fabric: string;
  items: Array<{
    id: string;
    name: string;
    sku: string;
    // 添加其他ProductInterface字段
  }>;
  page_info: {
    current_page: number;
    page_size: number;
    total_pages: number;
  };
  total_count: number;
}

export const useGetFabric = (pageSize: number = 12, currentPage: number = 1) => {
  const {
    loading, error, data 
  } = useQuery<{ allFabricProduct: AllFabricProductData }>(
    GET_ALL_FABRIC_PRODUCTS,
    {
      variables: {
        pageSize, currentPage 
      },
    }
  );

  const {
    allFabricProduct
  } = data || {}

  const satinCharmeuseItems = useMemo(() => {
    if (!allFabricProduct || !Array.isArray(allFabricProduct)) {
      return undefined;
    }

    const foundItem = allFabricProduct.find((item) => item?.fabric === "Satin_Charmeuse");

    return foundItem?.items;
  }, [allFabricProduct]);

  const crystalSatinItems = useMemo(() => {
    if (!allFabricProduct || !Array.isArray(allFabricProduct)) {
      return undefined;
    }

    const foundItem = allFabricProduct.find((item) => item?.fabric === "Crystal_Satin");

    return foundItem?.items;
  }, [allFabricProduct]);


  return {
    loading,
    error,
    crystalSatinItems,
    satinCharmeuseItems
  };
};
